import React, {Component} from 'react';
import CreatorCampaignBriefZoid from './creator_campaign_brief_zoid';
import './index.scss';

class CreatorCampaignBrief extends Component {
    render() {
        return (
            <CreatorCampaignBriefZoid
                onBriefDataReadyChange={this.props.onBriefDataReadyChange}
                onContentResize={this.props.onContentResize} // required height handling to properly work on mobile devices.
                {...this.props}
            />
        );
    }
}
export default CreatorCampaignBrief;



// WEBPACK FOOTER //
// ./components/creator_campaign_brief/index.js